import { gql } from "@apollo/client"

const SCHEDULE_SKU_FRAG = gql`
  fragment ScheduleSkuFrag on SKUGraphType {
    id
    name
    capacity
    capacityUnit {
      id
      name
      codename
    }
  }
`

const SCHEDULE_VEHICLE_FRAG = gql`
  fragment ScheduleVehicleFrag on VehicleType {
    id
    registrationNumber
    vehicleType {
      id
      category
      capacity
    }
    depot {
      id
      name
    }
  }
`
const GRADE_PRICE_FRAG = gql`
  fragment GradePriceFrag on GradePriceType {
    id
    price
    priceUnit {
      id
      name
    }
    grade {
      id
      name
    }
  }
`

const TRANSPORT_DETAIL_FRAG = gql`
  fragment TransportDetailFrag on VehicleTransportDetailType {
    id
    farmWeight
    acceptedDeduction
    standardDeduction
    deductionRate
    weightApplicable
    transportPaidBy
    transportCost
    advancePaidBy
    advanceCost
    rejectionBourneBy
    remark
    pricingDoneOn
    gradePrices {
      id
      grade {
        id
        name
      }
      price
    }
  }
`

const SCHEDULE_LIST_FRAG = gql`
  fragment ScheduleListFrag on ScheduleType {
    id
    updated
    # Check For gatePass
    gatePass
    estimatedQuantity
    requiredQuantity
    farmWeight
    labourCount
    isNotified
    isEdited
    timeToLeave
    timeToReach
    # isSelected @client
    # isEditable @client
    # Check for remark
    remark
    # Check for gradePrices
    gradePrices {
      id
      grade {
        id
      }
      price
    }
    booking {
      inwards {
        status
      }
    }
    sourceDepot {
      id
      name
    }
    destinationDepot {
      id
      name
    }
    company {
      id
      name
      displayName
      codename
    }
    # Check for skuType
    skuType {
      ...ScheduleSkuFrag
    }
    farmQuantityUnit {
      id
      name
      codename
    }
    cropGroup {
      id
      isFinishedGood
      isRawMaterial
      name
    }
    variety {
      id
      name
      groups {
        id
        name
        isFinishedGood
        isRawMaterial
        codename
      }
      preferredSku {
        id
        name
        capacity
        capacityUnit {
          id
          name
        }
      }
      commodity {
        id
        name
      }
    }
    # Check for plotCommodity
    plotCommodity {
      id
      name
      registrationCode
      generatePoPlotWise
      isFinishedGood
      isRawMaterial
      alternateCropGroup {
        id
        name
      }
    }
    # Check for plot
    plot {
      id
      name
      company {
        id
      }
      farmer {
        id
        fullName
        isBlocked
        blockRemark
        firstName
        lastName
        companies {
          id
        }
      }
      certifications {
        id
        certificationType {
          id
          name
        }
        certificationNumber
      }
      address {
        id
        village
      }
    }
    aggregator {
      id
      fullName
      firstName
      lastName
    }
    vehicle {
      id
      registrationNumber
    }
  }
  ${SCHEDULE_SKU_FRAG}
`

export {
  GRADE_PRICE_FRAG,
  SCHEDULE_LIST_FRAG,
  TRANSPORT_DETAIL_FRAG,
  SCHEDULE_SKU_FRAG,
  SCHEDULE_VEHICLE_FRAG,
}
